import { render, staticRenderFns } from "./FreightLines.vue?vue&type=template&id=58132b1d&scoped=true&"
import script from "./FreightLines.vue?vue&type=script&lang=js&"
export * from "./FreightLines.vue?vue&type=script&lang=js&"
import style0 from "./FreightLines.vue?vue&type=style&index=0&id=58132b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58132b1d",
  null
  
)

/* custom blocks */
import block0 from "./FreightLines.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports